import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import StartGameFlowLayout from "../components/StartGameFlowLayout";
import { INITIAL_GROUP_CAPITAL_M, ROUTES } from "../utils/constants";
import { setLastTickNow, updateStats, updateTimer } from "../utils/helpers";
import { fetchGameIfPlayAllowed } from "../utils/gamePlayGuard";
import reglas3 from "../assets/avatares/reglas-3.mp4";

export default function GameIntroduction() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = useState(false);

	const handleNext = () => {
		if (loading) return;
		setLoading(true);
		void fetchGameIfPlayAllowed(game?._id)
			.then(({ ok }) => {
				if (!ok) {
					setLoading(false);
					return;
				}
				const t0 = 0;
				updateTimer(t0);
				setLastTickNow();
				updateStats({
					...group,
					actualScenario: 2,
					time: t0,
					lastVisited: ROUTES.TRANSITION_SCENARIOS,
				});
				navigate(ROUTES.TRANSITION_SCENARIOS, {
					state: { activeScenario: 2 },
				});
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	return (
		<StartGameFlowLayout
			brandTheme
			sidebarTitle="Reglas Dinámica III"
			loading={loading}
			onContinue={handleNext}
			video={reglas3}
		>
			<div className="start-game-rule-block">
				<h3>Tiempo limitado</h3>
				<p>
					Tienes 8 minutos para completar el reto.
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>Capital inicial</h3>
				<p>
					Dispones de un capital inicial de <span className="start-game-mark-ok">{INITIAL_GROUP_CAPITAL_M}M€</span>. El objetivo es hacer crecer ese capital a través de las decisiones que tomes en cada escenario.
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>Atención</h3>
				<p>
					No está permitido manipular material que no esté identificado como
					parte del juego.
				</p>
			</div>
			<div className="start-game-rule-block start-game-rule-block--emphasis">
				<h3>Recuerda</h3>
				<p>
					No se trata solo de responder bien, sino de demostrar que llevas a Cobega en el ADN. Que compartes sus valores, su compromiso y la convicción de que el futuro se construye en equipo, colaborando y avanzando hacia una misma meta.
				</p>
			</div>
		</StartGameFlowLayout>
	);
}
